// @flow
import styles from './Dashboard.less';

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import SignedInDashboard from './SignedInDashboard/SignedInDashboard';
import SignedOutDashboard from './SignedOutDashboard/SignedOutDashboard';
import { ScreenReaderOnly } from 'seek-style-guide/react';

const mapStateToProps = ({ user }) => ({
  authenticated: user.authenticated
});

type Props = {
  authenticated: boolean
};

class Dashboard extends PureComponent<Props> {
  props: Props;

  render() {
    const { authenticated } = this.props;

    return (
      <section className={styles.root}>
        <ScreenReaderOnly>
          <h1>Dashboard</h1>
        </ScreenReaderOnly>

        {authenticated ? <SignedInDashboard /> : <SignedOutDashboard />}
      </section>
    );
  }
}

export default connect(mapStateToProps)(Dashboard);
